import React from "react";
export class FaqBanner extends React.Component { 
    constructor(props) {
        super(props);
    }

    render() { 
        return (
            <div className="faq-header">
                <div className="big-title"></div>
                <div className="img"></div>
            </div>
        ) 
    }
}